import { Rule } from '@leprecoins/effector-forms';

export const notEmptyRule: Rule<unknown> = {
	name: 'not-empty',
	validate: (value: unknown) =>
		value !== null && (typeof value === 'string' ? value.length > 0 : true),
};
